// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6934) return "static/chunks/6934-138525ec518a96cb.js";
	if (chunkId === 9910) return "static/chunks/a4634e51-0229cb859f82f271.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"6851":"79ff2c8e","8950":"01db7e4b"}[chunkId] || chunkId) + "." + {"39":"840fef942323d65b","1707":"27a267d157630cb3","3141":"4a23d7f29e2bce57","6851":"4a15ffc0607fa940","8950":"cd72a85115d61e86"}[chunkId] + ".js";
};